/**
 * OrbDocGettingStartedIntroductionSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocGettingStartedIntroductionSLDocScreen
 */

import { useOrbDocGettingStartedIntroductionSLDocScreenLogic } from '@/hooks/traits/useOrbDocGettingStartedIntroductionSLDocScreenLogic';
import type { OrbDocGettingStartedIntroductionSLDocScreenConfig } from '@/hooks/traits/useOrbDocGettingStartedIntroductionSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocGettingStartedIntroductionSLDocView as OrbDocGettingStartedIntroductionSLDocViewEntity } from '@app/shared';
import { OrbDocGettingStartedIntroductionSLDocBodyView } from '@/components/traits/OrbDocGettingStartedIntroductionSLDocBodyView';
import { OrbDocGettingStartedIntroductionSLDocFooterView } from '@/components/traits/OrbDocGettingStartedIntroductionSLDocFooterView';
import { OrbDocGettingStartedIntroductionSLDocHeaderView } from '@/components/traits/OrbDocGettingStartedIntroductionSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocGettingStartedIntroductionSLDocScreenViewProps {
  config?: Partial<OrbDocGettingStartedIntroductionSLDocScreenConfig>;
}

export function OrbDocGettingStartedIntroductionSLDocScreenView({ config: propsConfig }: OrbDocGettingStartedIntroductionSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocGettingStartedIntroductionSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocGettingStartedIntroductionSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocGettingStartedIntroductionSL" trait="OrbDocGettingStartedIntroductionSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocGettingStartedIntroductionSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocGettingStartedIntroductionSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocGettingStartedIntroductionSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocGettingStartedIntroductionSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocGettingStartedIntroductionSLDocScreenView;
